import { render, staticRenderFns } from "./ModalRegistTeacher.vue?vue&type=template&id=6a43daec&scoped=true&lang=pug&"
import script from "./ModalRegistTeacher.vue?vue&type=script&lang=ts&"
export * from "./ModalRegistTeacher.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a43daec",
  null
  
)

export default component.exports